import { getItemsFromCollection } from "directus/src/operations";

export async function fetchBucketJobConfig({ jobId }) {
  try {
    const query = {
      fields: ["id", "amount", "currency", "hours","budget_margin"],
      filter: {
        job: {
          _eq: jobId,
        },
      },
    };

    const response = await getItemsFromCollection("bucket_job_config", query);
    const item = response[0];
    if (item) {
      if (typeof item.amount === "string") item.amount = Number(item.amount);
      if (typeof item.hours === "string") item.hours = Number(item.hours);
    
    }
    return item;
  } catch (error) {
    console.error("Error fetching bucket config:", error);
    throw error;
  }
}
